import { Navigation } from "./components/navigation";
import { Research } from "./components/research";
import { Contact } from "./components/contact";
import { ProfServ } from "./components/profServ";
import { Teaching } from "./components/teaching";
import { BioNote } from "./components/bioNote";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  return (
    <div>
      <Navigation />
      <Research />
      <ProfServ />
      <Teaching />
      <BioNote />
      <Contact />
    </div>
  );
};

export default App;
